import { GET_AUCTION } from "core/apollo/graphql";
import { useApolloEncryptionContext } from "core/model/patients/encryption/utils";
import { Auction } from "core/types";
import { useLazyQuery } from "./utils";

export function useLazyGetAuction() {
  const encryptionContext = useApolloEncryptionContext();
  const [getAuction] = useLazyQuery<
    { auction: Auction },
    { auctionId: number | null | undefined }
  >(GET_AUCTION, {
    encryptionContext,
    fetchPolicy: "network-only",
  });

  return (id: number | null | undefined) => getAuction({ auctionId: id });
}
